<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="btnclick" :pageData="pageData"></table-page>
    <!-- Comment Dialog -->
    <Dialog ref="childDialog" :dialogData="dialogData" :title="dialogTitle"></Dialog>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '../../components/page/table.vue'
    import FORM from '../../components/page/form.vue'
    import Dialog from './dialog.vue'

    //接口地址url的统一管理
    import URL from '@/views/mis/util/url'
    import AUTH from '@/views/mis/util/auth'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'

    const requestOptions = {
	    headers: {"Content-Type": "application/json"},
        responseType: "blob",
    }

    const accountStatusOptionList = [
        {key: 0, value: window.$t("mis.nps.accountTypeOption1")},
        {key: 2, value: window.$t("mis.nps.accountTypeOption2")},
        {key: 4, value: window.$t("mis.nps.accountTypeOption3")},
        {key: 1, value: window.$t("mis.nps.accountTypeOption4")},
        {key: 3, value: window.$t("mis.nps.accountTypeOption5")},
        {key: 5, value: window.$t("mis.nps.accountTypeOption6")},
    ];

    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            Dialog
        },
        methods: {
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName || window.$t('mis.bt.query') == clickName){
                    if(data) {
                        // console.log("Form data", data);
                        this.queryData.realAccount = data.realAccount ? data.realAccount : undefined;
                        this.queryData.simAccount = data.simAccount ? data.simAccount : undefined;
                        this.queryData.fromTime = data.timeRangeStart ? DateUtil.formatDate(data.timeRangeStart, "yyyy-MM-dd hh:mm:ss") : undefined;
                        this.queryData.toTime = data.timeRangeEnd ? DateUtil.formatDate(data.timeRangeEnd, "yyyy-MM-dd hh:mm:ss") : undefined;
                        this.queryData.fromScore = data.scoreRange ? (!isNaN(parseInt(data.scoreRange[0])) ? parseInt(data.scoreRange[0]) : undefined) : undefined;
                        this.queryData.toScore = data.scoreRange ? (!isNaN(parseInt(data.scoreRange[2])) ? parseInt(data.scoreRange[2]) : undefined) : undefined;
                        this.queryData.accountType = data.accountType ? data.accountType : 0;
                    }
                    // console.log("queryData", this.queryData);
                    this.$refs.childTable.defaultQueryData(this.queryData);
                } else if(window.$t('mis.bt.export') == clickName) {
                    this.confirmAction(clickName, "export");
                }
            },
            btnclick(clickName, row){
                if("view" == clickName) {
                    // Set dialog data
                    this.getComment(row.npsId);
                    this.$set(this.dialogData[0], "value", row.score);
                    this.$set(this.dialogData[1], "value", this.parseNpsType(row.types));
                    // console.log("dialogData", this.dialogData);
                    this.$refs.childDialog.show();
                }
            },
            getComment(id) {
                let url = URL.nps.comment + "/" + id;
                this.$axios.get(url).then(res=> {
                    if (res.code == 0 && res.result != undefined) {
                        this.$set(this.dialogData[2], "value", res.result);
                    }else{
                        this.$message.error(res.message);
                    }
                });
            },
            confirmAction(clickName, action) {
                this.$confirm(window.$t('mis.nps.confirmDownload'), window.$t('mis.nps.confirmMessageTitle'), {
                confirmButtonText: window.$t('mis.nps.confirmButton'),
                cancelButtonText: window.$t('mis.nps.cancleButton'),
                type: 'warning'
                }).then(() => {
                    this.requestExcel(action);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: window.$t('mis.nps.cancleMessage') + clickName
                    });          
                });
            },
            requestExcel(action) {
                let {pageSize, pageNum, ...params} = this.queryData;
                this.$axios.post(URL.nps.export, JSON.stringify(params), requestOptions).then((res) => {
                    const data = res.data == null ? res : res.data;
                    const blob =new Blob([data], { type: 'application/vnd.ms-excel' });
                    
                    const href = window.URL.createObjectURL(blob);
                    
                    const anchorElement = document.createElement('a');
                    
                    anchorElement.href = href;

                    // 1) Get the value of content-disposition header
                    const contentDisposition = res.headers == null ? "" : res.headers['Content-Disposition'];
                    // console.log('contentDisposition: ', contentDisposition);

                    // 2) set the fileName variable to the default value
                    let fileName = "nps_"+action+"_excel_"+ Date.now() +".xlsx";

                    // 3) if the header is set, extract the filename
                    if (contentDisposition) {
                        const fileNameMatch =
                        contentDisposition.match(/filename="(.+)"/);
                        // console.log('fileNameMatch', fileNameMatch);
                        if (fileNameMatch.length === 2) {
                        fileName = fileNameMatch[1];
                        }
                    }

                    anchorElement.download = fileName;

                    document.body.appendChild(anchorElement);
                    anchorElement.click();

                    document.body.removeChild(anchorElement);
                    window.URL.revokeObjectURL(href);    
                }).catch(err => {
                    console.error(err);
                })
            },
            parseNpsType(npsTypes) {
                let types = "";
                npsTypes.forEach(element => {
                    types += element + ", ";
                });
                return types.substring(0, types.length - 2);
            }
        },
        data () {
            return {
                queryData:{
                    // realAccount: "",
                    // simAccount: "",
                    // fromTime: "",
                    // toTime: "",
                    // fromScore: "",
                    // toScore: "",
                    // accountType: 0,
                },
                dialogTitle: window.$t('mis.nps.comment'),
                dialogData: [
                    {label: window.$t('mis.nps.score'), value: 0},
                    {label: window.$t('mis.nps.npsType'), value: ""},
                    {label: window.$t('mis.nps.comment'), value: ""},
                ],
                /*from查询表单*/
                formData:{
                  hasLable: true,
                  cols:[
                      { title: window.$t('mis.nps.realAccount'), field: 'realAccount'},
                      { title: window.$t('mis.nps.simAccount'), field: 'simAccount'},
                      { title: window.$t('mis.nps.createdTime'), field: 'timeRange', type: 6},
                      { title: window.$t('mis.nps.socreRange'), field: 'scoreRange', type: 8, min: 0, max: 10},
                      { title: window.$t('mis.nps.accountType'), field: 'accountType', type: 2, optionList: accountStatusOptionList, placeholder: accountStatusOptionList[0].value},
                      { click: window.$t('mis.bt.query'), auth: "mis:app:nps:query"},
                      { click: window.$t('mis.bt.export'), auth: "mis:app:nps:export"}
                  ]
                },
                /*table生成*/
                pageData: {
                    method: "post",
                    fieldTotal: "recordsFiltered",
                    fieldData: "data",
                    isShow: false,
                    queryUrl: URL.nps.query, //请求路径和参数
                    sequence: true,
                    cols: [
                        { title: window.$t('mis.nps.npsId'), field: 'npsId'},
                        { title: window.$t('mis.nps.realAccount'), field: 'realAccount'},
                        { title: window.$t('mis.nps.simAccount'), field: 'simAccount'},
                        // { title: window.$t('mis.nps.mobile'), field: 'mobile'},
                        { title: window.$t('mis.nps.score'), field: 'score'},
                        { title: window.$t('mis.nps.npsType'), field: 'types', render(val, row) {
                            let types = "";
                            val.forEach(element => {
                                types += element + ", ";
                            });
                            return types.substring(0, types.length - 2);
                        }},
                        { title: window.$t('mis.nps.comment'), field: 'comment'},
                        { title: window.$t('mis.nps.createdTime'), field: 'createdTime'},
                        { title: window.$t('mis.nps.deviceOs'), field: 'deviceOs'},
                        { title: window.$t('mis.nps.appVersion'), field: 'appVersion'},
                        { title: window.$t('mis.nps.isTestingAccount'), field: 'isTestingAccount', render(val, row) {
                            if (val) return window.$t('mis.nps.isTestingAccountTrue');
                            else return window.$t('mis.nps.isTestingAccountFalse');
                        }},
                        { title: window.$t("common.handle"), btnClick: [
                            {name: window.$t("mis.nps.checkCommentButton"), click:"view",type:"primary", icon: "el-icon-view", auth:"mis:app:nps:view"},
                        ]}
                    ]
                }
            }
        }
    }
</script>
